import styled from 'styled-components';

export const SwiperCardsContainer = styled.div<{ alignCenter?: boolean }>`
  .swiper-wrapper {
    justify-content: ${({ alignCenter }) => (alignCenter ? 'center' : 'inherit')};
  }
`;
